import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Library() { 
  useEffect(() => {
    document.title = 'Library -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Rules</li>
                <li>Library</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Library</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12"> 
                    <p>Books let you travel without moving your feet. <span>-Jhumpa Lahiri</span></p>     
                    <p>Students are encouraged to read books. The school library has been set up with the sole objective of providing good books to the students. A number of useful periodicals are also available in the library.</p>
                    <ul className="mainlist">
                   <li>Students should remain silent inside the library and move in silence to and from the library. They should always move in a line.</li>
                   <li>All students are expected to visit the library as scheduled and read books/ periodicals of their interest. Students who wish to carry books to read at home are permitted to do so provided they do not carry more than one book at a time.</li>
                   <li>One book is issued for a period of one week. The book will have to be returned to the library latest by the eighth day of issue. If the eighth day falls on a holiday, the next working day will be considered as the eighth day. Fine @ Rs.1/- per day will be charged for not returning the book on time. Students may reissue the same book.</li>
                   <li>Students must handle books very carefully, so as not to damage or deform the book in any way. Any damage to the book will be treated seriously and such students will be charged the cost of that book according to the existing market price along with postage charges. Parents will have to remit the amount on the following day of receiving instruction from the librarian at the fee counter and get a receipt for the amount deposited.</li>
                   <li>Students who do not return the book on time will not be eligible for getting books issued, for two months. Repetition of the same will invite permanent ban on carrying books home. Principal is the final authority and his decision will be final and binding.</li>
                  </ul>  
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Library;
